import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../services/settings/settings.service';
import { tabs } from './model';

@Component({
  selector: 'billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss', '../settings.scss'],
  standalone: false,
})
export class BillingComponent implements OnInit {
  tabsData = tabs;
  isLoading = true;

  constructor(private myService: SettingsService) {}

  ngOnInit(): void {
    this.loadInfo();
  }

  async loadInfo() {
    const subscriber = this.myService.getLatestPlan().subscribe((plan) => {
      this.tabsData = this.tabsData.filter((tab) => tab.displayed(plan!));
      this.setDefaultActiveTab();
      this.isLoading = false;
    });
  }

  private setDefaultActiveTab() {
    this.tabsData.map((t) => (t.active = false));
    this.tabsData[0].active = true;
  }

  isActiveTab(name) {
    return this.tabsData.find((tab) => tab.value == name)?.active;
  }

  switchTab(e) {
    this.tabsData.forEach((t) => (t.active = false));
    const selected = this.tabsData.find((t) => t.value === e);
    selected.active = true;
  }
}
